'use strict';
define([
    'angular',
    'modules/settings/overview/overview.controller'
],function(angular,SettingsOverviewCtrl){
    var app=angular.module('settings.overview', []);
    app.controller('SettingsOverviewCtrl',SettingsOverviewCtrl);
    return app;
});
